import { PreviousDialog } from './previous_dialog.entity';
var SessionContinuation = /** @class */ (function () {
    function SessionContinuation(props) {
        if (props.previousDialog) {
            this.previousDialog = new PreviousDialog(props.previousDialog);
        }
        this.previousState = props.previousState;
    }
    return SessionContinuation;
}());
export { SessionContinuation };
